export default {
  map: {
    lnglat: [69.175, -78.277],
    zoom: 5.9,
    tileLayer: {
      url:
        'https://api.mapbox.com/styles/v1/codelf/cjoa7t23p0y3r2sml4cxvyud0/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiY29kZWxmIiwiYSI6InJqWGhtbTAifQ.JxxPn_cs-FbjD0UP7Lqovg',
      config: {
        minZoom: 4,
        maxZoom: 15,
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
          '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
          'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
      }
    }
  }
}
